export const OrderStatus = [
  'working',
  'traded',
  'reverted',
  'expired',
  'cancelled',
] as const;

export const TradeStatus = ['traded', 'busted'] as const;
